import { observer } from 'mobx-react-lite';
import React from 'react';
import { IColorwayProductData, IProduct, TUserSelections } from '../../product/types/PDP';
import { addItemToWishlist, removeItemFromWishlist, wishlistState } from './wishlistState';
import { promptAuthAndWishlistFromURL } from './wishlistUtils';

let WishlistButtonPDP = ({
  product,
  userSelections,
  isCustomer,
  // LND-2678: [AB Test]
  shouldShowOmniPdpExperience,
}: {
  product: IProduct;
  userSelections: TUserSelections;
  isCustomer: boolean;
  shouldShowOmniPdpExperience?: boolean;
}) => {
  const selectedColor = userSelections[0].Color || '';
  const wishlistPDPData = product.productDataByColorName[selectedColor];
  const { colorName, id, title, productType, variants } = wishlistPDPData as IColorwayProductData;
  const selectedVariant =
    productType === 'Gift Card'
      ? variants.find((item) => item.selectionOptions.Size === userSelections[0].Size)
      : variants[0];
  const variant = Array.isArray(selectedVariant) ? selectedVariant[0] : selectedVariant;
  const price = variant?.price;
  const displayPrice = variant?.displayPrice;
  const priceInCents = price && price / 100;
  const displayPriceInCents = displayPrice && displayPrice / 100;
  const wishListGA4ProductData = {
    source: 'pdp',
    variantTitle: colorName + (userSelections[0].Size ? ` / ${userSelections[0].Size}` : ''),
    id: id,
    title: title,
    productType: productType,
    variants: variants || [],
    price: price,
    displayPrice: displayPrice,
    discount: displayPriceInCents && priceInCents && displayPriceInCents - priceInCents,
  };

  const isWishlisted = wishlistState.productIds.includes(Number(wishListGA4ProductData?.id));

  const toggleItemInWishlist = () => {
    if (isWishlisted) {
      removeItemFromWishlist(wishListGA4ProductData, {
        isSignedIn: isCustomer,
        productId: wishListGA4ProductData?.id,
        source: 'PDP',
        'Wishlist Items Count': wishlistState.productIds.length - 1,
      });
    } else {
      addItemToWishlist(wishListGA4ProductData, {
        isSignedIn: isCustomer,
        productId: wishListGA4ProductData?.id,
        source: 'PDP',
        'Wishlist Items Count': wishlistState.productIds.length + 1,
      });
    }
  };

  const buttonStyles: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    gap: 10,
    width: shouldShowOmniPdpExperience ? `auto` : `100%`,
    ...(shouldShowOmniPdpExperience && { padding: `14px var(--spacing-md)` }),
  };

  return (
    <button
      style={buttonStyles}
      className="button-ghost uppercase"
      onClick={async () => {
        if (!wishlistState.error && isCustomer) {
          toggleItemInWishlist();
        } else if (wishlistState.error === 'unauthorized' || !isCustomer) {
          promptAuthAndWishlistFromURL('PDP', wishListGA4ProductData);
        } else
          console.log('Something went wrong with fetching wishlist: ', {
            productIds: wishlistState.productIds,
            error: wishlistState.error,
          });
      }}
    >
      {isWishlisted ? (
        <>
          <span className="icon-wishlist-solid"></span>
          {!shouldShowOmniPdpExperience && `Remove From Wishlist`}
        </>
      ) : (
        <>
          <span className="icon-wishlist-static"></span>
          {!shouldShowOmniPdpExperience && `Add to Wishlist`}
        </>
      )}
    </button>
  );
};

WishlistButtonPDP = observer(WishlistButtonPDP);
export { WishlistButtonPDP };
